import {Component} from '@angular/core';

import {GeneralListComponent} from '../../general/list/generalList.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from '../../../../shared/message.service';
import {AdditionalRightService} from '../../../services/additional-right.service';
import {AdditionalRight} from '../../../interfaces/additionalRight';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-additional-rights',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class AdditionalRightListComponent extends GeneralListComponent<AdditionalRight> {

  constructor(
    service: AdditionalRightService,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'additional right',
        entityNamePlural: 'additional rights',
        formUrl: 'additionalright',
        listUrl: 'additionalrights',
        generalFormMetaName: 'additional-right',
      },
    );
  }
}
